module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t6",
      "id": "c6"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#t6"
    }
  }, [_vm._v("Things to Know About Your Job Search as a Recent College Graduate")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p31.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('b', [_c('i', [_vm._v("In the end, what we regret most are the chances we never took.")])])]), _vm._v(" "), _c('p', {
    staticClass: "aut"
  }, [_vm._v("—Frasier Crane"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt3",
      "id": "ch1_ft3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#t7",
      "id": "c7"
    }
  }, [_vm._v("Job Search Methods")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("There are four generally accepted job search methods for recent college graduates that generate the most job leads:")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_vm._v("1. On-Campus Career Fairs")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_vm._v("2. Networking (through various means and sources)")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_vm._v("3. Direct - Proactively Marketing Your Collegiate Credentials to Employers")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_vm._v("4. Job Boards and Online Job Applications")]), _vm._v(" "), _c('p', {
    staticClass: "tx12"
  }, [_vm._v("All four methods could lead you to your next career position. However, some are more effective than others.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('i', [_vm._v("On-Campus Career Fairs")])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The on-campus career fair is one of the time-efficient job search strategies available to you. Career fairs are convenient and allow you to interact with a number of employers in a reasonably short period of time. For the employers, there is already a general interest in meeting you and your peers, otherwise the employer would not be attending.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Networking")])])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Networking is an effective job search method. It is estimated that 60 to 80 percent of all jobs are found through some form of networking."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ch1_nt4",
      "id": "ch1_ft4"
    }
  }, [_vm._v("4")]), _vm._v(" However, networking as a recent college graduate presents some challenges because most graduates do not have a developed network of professional connections to tap into. Nonetheless, there are ways to successfully use networking as a recent college graduate.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Direct - Proactively Marketing Your Collegiate Credentials to Employers")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This is a method where you approach an employer directly regardless of whether there is a known job opening. It can be very effective when properly executed. This requires preparation and effort, and it will differentiate you from the vast majority of other recent college graduates.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Job Boards and Online Job Applications")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This method tends to be the least effective and the statistics are not promising. It’s been referenced that for every online posting there are 118 applicants."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt5",
      "id": "ch1_ft5"
    }
  }, [_vm._v("5")])]), _vm._v(" The odds of you getting a job from an online job posting are less than one percent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Should you even bother to apply to jobs posted online? Yes, though selectively. If you find a posted job opening that you are clearly qualified for, attempt to identify the actual hiring executive. Contact that person directly using the techniques described in this book (from the Direct approach referenced above). If that is unsuccessful, then apply for the position online.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you know the specific industries you are interested in, follow specialized job boards used by employers in those industries. This can increase your chances of success.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But most importantly, control your expectation of success when applying for jobs posted online (job boards) and do not rely upon it as your main job search method.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This method will not be specifically discussed in the book except by occasional reference.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bxt"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('i', [_vm._v("What the Coaches Say:")])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("In your experience, what are the most effective job search methods for recent college graduates? (E.g. On-campus career fairs, networking, job boards, etc.)")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Regardless of career level, new college graduate or chief executive officer, a recent survey reveals 85% of ALL jobs are filled via networking ("), _c('i', [_vm._v("LinkedIn Recruiting & Hiring, 2/29/16")]), _vm._v("). College students can network at campus career fairs, yes, but their best strategy is to identify, nurture and grow their “Circle of Champions,” friends, family, colleagues and peers within their network. Then, add Prospects, 2"), _c('sup', [_vm._v("nd")]), _vm._v(" and 3"), _c('sup', [_vm._v("rd")]), _vm._v(" level connections and Activators, 1"), _c('sup', [_vm._v("st")]), _vm._v(" connections, in targeted companies to their network. Other ways to build a Circle of Champions are to join industry associations as a student member, network at community events, and connect and interact with alumni via LinkedIn. Use the Circle of Champions to ask for introductions to 2"), _c('sup', [_vm._v("nd")]), _vm._v(" or 3"), _c('sup', [_vm._v("rd")]), _vm._v(" level connections or to people in their Circle.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Dr. Cheryl Minnick, NCRW, CCMC, CHJMC, CAA")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("I recommend all students attend job fairs to start talking to a broad range of potential employers. They should have a great introduction about themselves (elevator pitch) and have a plan prior to attending since many colleges post which employers will be there in advance. I also recommend students join associations in their career field, as many will have reduced membership fees or none for college students. For example a student wanting to be in Human Resources should join the Society for Human Resources Management (SHRM). Networking is always critical. New grads, like all people, should be networking their inner and outer circle.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Ellen Steverson, NCRW, GCDF, CEIC")])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t8",
      "id": "c8"
    }
  }, [_vm._v("Your Job Search Arsenal: Considerations, Tools, and Tactics")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("The following is a reasonably comprehensive, though not necessarily an exhaustive list of considerations, tools, and tactics for a college graduate job search. The checklist is designed as a visual reminder of the tools and tactics at your disposal. Use it as a checklist as you prepare for your search as well as action items as you proceed. Read the chapters in this book for in-depth information.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’s recommended that you review this list every once in a while as a reminder of what you should be doing or can be doing to advance your job search.")]), _vm._v(" "), _c('table', {
    staticClass: "table-border"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "55%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "15%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdc1"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('b', [_vm._v("Item")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdc1"
  }, [_c('b', [_vm._v("Comments")])]), _vm._v(" "), _c('td', {
    staticClass: "tdc1"
  }, [_c('b', [_vm._v("Check off")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Cleanse all social media sites")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("All inappropiriate pictures and comments must be deleted.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Emotions - positive attitude")]), _vm._v(" "), _c('td', [_vm._v("Stay away from negative throughts / feelings. Keep a positive attitude.")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Resume")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("It is imperative to have an impactful resume.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("LinkedIn profile")]), _vm._v(" "), _c('td', [_vm._v("Like a resume, an optimized LinkedIn profile is imperative to your job search.")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Business cards")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "tx1"
  }, [_vm._v("Select the one(s) you will use in your search:")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Traditional")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Networking")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Resume")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Infographic")])]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Keywords")]), _vm._v(" "), _c('td', [_vm._v("Know the keywords that apply to you especially for your LinkedIn profile and resume.\n")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Job Alerts")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("Get a flow of job openings by setting up job alerts.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Master job description")]), _vm._v(" "), _c('td', [_vm._v("Doing this helps you think like the hiring executive.")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Accomplishments")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("Know what differentiates you.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Transferrable skills and professional qualities")]), _vm._v(" "), _c('td', [_vm._v("Those skills and qualities that make you truly unique and are often sought after by employers.")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Success stories")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("Pre-write three. Helps in interviews and answering behavior based questions.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Personal branding")]), _vm._v(" "), _c('td', [_vm._v("Those words and statements that announce to the market who you are and what you offer.\n")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Elevator speech")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("Who you are, accomplishments, start a conversation, scripted and practiced.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cover letter")]), _vm._v(" "), _c('td', [_vm._v("Write a template. Then modify. Use as a marketing email.")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("List target employers")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("Create a list. Add new employers when they are discovered.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Short-list of networking contacts")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("People you can reach out to about your job search.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Networking")]), _vm._v(" "), _c('td', [_vm._v("A high percentage of all jobs are found through some form of networking.")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Ice breaker questions")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("Prepared in advance of on-campus career fairs, networking events. Having them reduces anxiety in conversations.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tx1"
  }, [_vm._v("Proactively marketing your collegiate credentials by phone")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Script marketing call")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Voicemail script")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Responses to objections")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Script for handling the gatekeeper")])]), _vm._v(" "), _c('td', [_vm._v("This approach is the most direct method for getting interviews and job leads.")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Proactively marketing your collegiate credentials by email")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("This approach can be easier to execute but follow up calls must be made.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Drip marketing")]), _vm._v(" "), _c('td', [_vm._v("Used to stay in touch with a hiring executive with new information.")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Last ditch effort email")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("Last email contact to a hiring executive that is not responding.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tx1"
  }, [_vm._v("Interviewing")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Scripted answers to common questions")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Research")])]), _vm._v(" "), _c('td', [_vm._v("A lot of information about interviewing in the book. Prepare for common or anticipated questions. Do research before every interview.")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("References")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("Wisely chosen and listed. Unsolicited third party affirmation technique.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Direct U.S. mail contact to hiring executives")]), _vm._v(" "), _c('td', [_vm._v("Traditional approach. Can be useful for hard-to-reach hiring executives or as a last ditch effort.")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Career fairs")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("Useful for some college job seekers.")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Emotion - rejections")]), _vm._v(" "), _c('td', [_vm._v("Disappointments will happen. Continue to move forward. Don’t get stuck!")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Effort")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("Stay busy!")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circleg.jpg"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Avoid busy-work")]), _vm._v(" "), _c('td', [_vm._v("Focus on those tasks that truly advance your search.")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ser0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/circle.jpg"
    }
  })])])])])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t9",
      "id": "c9"
    }
  }, [_vm._v("★ "), _c('b', [_vm._v("Clean Up All Social Media Before Starting a Job Search")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Take this fact very seriously: Around 33 percent of employers have rejected candidates based on information discovered on social media."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt6",
      "id": "ch1_ft6"
    }
  }, [_vm._v("6")])]), _vm._v(" This is significant! Consider the ramifications—you put in years of effort, focus, and perseverance towards your college degree. You got good grades and worked as a summer intern. But a potential employer rejects you (and you may not even know it) for unprofessional or inappropriate information on your social media sites. All of your time and effort is blown. And, there’s no recovery once it happens.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Today, it is imperative that you clean up all of your social media sites "), _c('i', [_vm._v("before")]), _vm._v(" you start a job search. It is recommended that the cleansing process begins a few months in advance of actual job search activities. This allows for plenty of time for deleted information to cleanse itself out of cyber-space. Then, after you have cleansed your social media sites, wait awhile and again, before engaging in active job search activities, double check all social media for inappropriate information. Re-cleanse as necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Part of this cleansing process includes getting “tagged” into inappropriate conversations. You may need to inform your friends or block them from tagging you if necessary. If you have a pseudo (secondary) account under another name, perhaps it is time to close and delete it. Ask yourself, is it worth the risk of discovery to get passed over for a job, or even possibly fired? The answer is obvious.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Cleaning up your social media sites is not hard, but you must be thorough. Start by running a Google search on your name. Delete all inappropriate photos and written content wherever you find it. Consider tightening your privacy settings as necessary after all inappropriate photos and content have been removed. Run a search for yourself in each and every social media site which you have an account. Cleanse everything everywhere you find it! There are now services that will scan and scrub your social media for harmful posts. Check into "), _c('a', {
    attrs: {
      "href": "http://www.repnup.com",
      "id": "ABj",
      "target": "_blank"
    }
  }, [_vm._v("www.repnup.com")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://www.scrubber.social",
      "target": "_blank"
    }
  }, [_vm._v("www.scrubber.social")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Begin professionalizing your social media sites. Post new photos that represent you in a positive light. All new content should also have a positive spin or be professionally appropriate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your college life is evolving into your professional career life. Along with that, you must evolve your social media life to support your professional career life.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t10",
      "id": "c10"
    }
  }, [_vm._v("What Employers Look for and Discover on Social Media")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("It is undeniable that social media will play a role in your job search. The significance of that role depends largely on how much you use social media. But employers also use social media.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To help you better understand the role of social media in your job search, CareerBuilder. com conducts a yearly survey that asks hiring managers and human resource professionals if, how, and why they incorporate social media into their hiring process.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The results from a recent survey found that out of the 2,300 hiring managers and human resource professionals 70 percent of employers use social networks to screen potential job candidates (this trend has consistently grown over the years)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt7",
      "id": "ch1_ft7"
    }
  }, [_vm._v("7")])]), _vm._v(" That means more and more companies browse your social media profiles to evaluate your character and personality. What they find about you will influence their hiring decision.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the survey, employers that chose not to pursue a job applicant after researching social media sites indicated the following reasons:")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "70%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Job seeker posted inappropriate pictures, videos or information")])]), _vm._v(" "), _c('td', [_vm._v("39 percent")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Found evidence of job seeker’s use of alcohol or drugs")])]), _vm._v(" "), _c('td', [_vm._v("38 percent")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Job seeker made negative remarks about previous employer or fellow employee")])]), _vm._v(" "), _c('td', [_vm._v("30 percent")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Discriminatory comments made about race, gender, religion, etc.")])]), _vm._v(" "), _c('td', [_vm._v("32 percent"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt8",
      "id": "ch1_ft8"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Poor communication skills")])]), _vm._v(" "), _c('td', [_vm._v("27 percent")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Lied about qualifications")])]), _vm._v(" "), _c('td', [_vm._v("27 percent")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Linked to criminal behavior")])]), _vm._v(" "), _c('td', [_vm._v("26 percent")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Shared confidential information from a previous employer")])]), _vm._v(" "), _c('td', [_vm._v("23 percent")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Screen name or handle was inappropriate or unprofessional")])]), _vm._v(" "), _c('td', [_vm._v("22 percent")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Lied about an absence")])]), _vm._v(" "), _c('td', [_vm._v("17 percent")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("However, over 44 percent of hiring executives discovered information that improved a job seeker’s candidacy, including:")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "70%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Job seeker’s background matched qualifications of position")])])]), _vm._v(" "), _c('td', [_vm._v("38 percent")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• A professional image")])]), _vm._v(" "), _c('td', [_vm._v("36 percent")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Creativity")])]), _vm._v(" "), _c('td', [_vm._v("35 percent")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Communication")])]), _vm._v(" "), _c('td', [_vm._v("37 percent"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt9",
      "id": "ch1_ft9"
    }
  }, [_vm._v("9")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("According to the research, employers utilize social media to gain additional insight into your behavior and personality outside the interview. They use all tools available to help ensure a good hire.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bxt"
  }, [_c('i', [_vm._v("What the Coaches Say:")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("What is your advice about cleaning up social media sites before starting a job search?")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Once, in an appointment with a student, I was talking about the importance of googling their own name in preparation for job searching in order to ensure all outward facing social media was in alignment with the image they wanted to portray professionally. The student shared, “I haven’t checked that in a long time, let’s see what my name generates.” I agreed and we googled their name. In the process of searching the search engine, a YouTube video popped up of the student, and he immediately turned red in the face. He then proceeded to tell me not to click on the icon, and I, of course, laughed with the student because it was a case and point of the importance of knowing what exists out there, and to “clean up” anything that could be deemed questionable by a future employer. Long story short, I encourage students and recent graduates to reflect on how they desire to present themselves professionally through social media, and remembering whatever they put out to social media is a representation of their values, identities, belief systems, and that ultimately, they don’t get to control how a person interprets what they see. It is better to be conservative and “clean up” their social media in order to present a polished and professional, outward facing image.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Jered Lish M.S., Gallup-Certified Strengths Coach, GCDF")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Before beginning a job search, conduct a 30-day social media cleanse. Check your social media privacy settings; add a vanity URL to LinkedIn, as well as an updated professional headshot and an un-polarizing picture to Facebook; confirm your contact data is correct. Pull or delete any political rants, unbecoming photos and content shares. Next, google yourself—potential employers do and they learn more about us through our social media which leads to judgment and application rejections. Identify and build a brand, market and manage that brand via your professional behavior, headshot, character, integrity, appearance, tweets and posts.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "txr"
  }, [_vm._v("Dr. Cheryl Minnick, NCRW, CCMC, CHJMC, CAA")])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t11",
      "id": "c11"
    }
  }, [_vm._v("How Important is Your GPA When Searching for a Job?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("The short answer: It depends.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A strong GPA (3.5 and above on a 4.0 scale) is clearly an advantage when searching for your first career-focused job. If you have achieved this level of academic success, congratulations! Your hard work has paid off. You’re in a good spot!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The importance of your GPA in your job search depends largely on your field of interest. Desirable employers in the fields of accounting, engineering, finance, science, technology, among others tend to use grade point average as a screening tool to limit the size of the overall candidate pool for sought-after positions. A high grade point average can qualify you for an interview with these selective employers, but it does not guarantee you a job. There are many other factors that come into play in securing employment beyond your GPA. (Much of this book is dedicated to those “other factors” to a successful job search.)")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bxt"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('i', [_vm._v("What the Coaches Say:")])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("What is your opinion regarding the importance of a G.P.A. and its influence on a graduate’s job search?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("Some employers recruit students based on G.P.A. Most understand that what you learned and how well you work with others is a better predictor of job success. If you are not in the top 10% of your class, be prepared to explain your G.P.A. Did working to pay for college impact the time you had to study? Did you choose challenging classes or a major where top grades were harder to earn? Do you excel in your field but not on tests? Explain why the mitigating factor will make you a better employee, and how you learned to work harder and smarter and focus on goals rather than on grades.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Lorraine Beaman, MA, ACRW, CARW, NCRW, CEIC, MCD")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Depending on the job a graduate is pursuing, a high GPA may be a requirement. For example, some highly competitive roles or employers may require a higher GPA to use as a screening process to reduce the list of potential candidates to consider for any position. Because a new graduate does not have a lot of experience, companies will rely on their performance in college as a gauge of how the candidate will perform on their job and how they will approach their work. In general, many companies will target a GPA of at least 3.0. However, the key is to understand that the GPA is used more as a filter than as a rule. If a candidate has a GPA that is less than 3.0, it does not necessarily mean that a company will not consider them; it just means that they should have some other qualities that will let them stand out and be competitive to the employer so they will still be a contender.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Juliet Murphy, MBA, MA")])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("For many employers, the first item of interest is the actual completion of the degree, followed by GPA and other factors. Completion of the degree is a demonstration of perseverance, work ethic, focus, dedication, and delayed gratification. All are sought-after qualities that employers look for in new hires. The thing to remember is employers are looking for skills that will translate into making or saving the company money or achieving organizational mission goals. A GPA is a factor but not an accurate way to measure for those abilities. Having soft skills like communication abilities, problem solving abilities, creative thinking, as well as previous experience through internships or working through school can be more valuable to an employer than a GPA.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("According to "), _c('i', [_vm._v("The Chronicle of Higher Education")]), _vm._v(" and "), _c('i', [_vm._v("American Public Media’s Marketplace")]), _vm._v(", relevant work experience is more important than academic GPA to many employers:")])]), _c('div', {
    staticClass: "bkt"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('p', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("“Employers place more weight on experience, particularly internships and employment during school vs. academic credentials including GPA and college major when evaluating a recent graduate for employment.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ch1_nt10",
      "id": "ch1_ft10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This reasoning makes sense. If a college graduate has a successful track record performing the tasks (or some of them) required in a position, it is a clear predictor of success regardless of academic GPA.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When it comes to your job search, your academic record will be a factor. However, it is not everything. Your job search success will likely turn on three additional things beyond your academic record: First is your ability to demonstrate value to an employer by referencing your previous work or internship experience. Then, proof of character traits and soft skills such as work ethic and honesty. Finally, the hiring decision will be influenced by cultural fit. That is, the subjective determination by an employer that you will blend into the company’s culture.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So how important is your GPA? It matters to qualify you with some companies in some industries for an interview. Beyond that, depending upon the employer, it can matter less. This can be good news for those with less than a stellar GPA. Work experience, character traits, and cultural fit tend to influence the hiring decision beyond the GPA.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bxt"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('i', [_vm._v("What the Coaches Say:")])])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("What are your thoughts regarding the importance of a G.P.A. and the overall success of a college graduate’s career?")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Research has consistently shown there is not a direct correlation between college G.P.A. and career success. College coursework provides the basic knowledge for entering a profession; it is hard work, commitment to continuous learning, and drive that are the key to professional success.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Lorraine Beaman, MA, ACRW, CARW, NCRW, CEIC, MCD")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("I think students should try to earn the highest grades possible. However, life happens and for those who have a lower GPA and still finish, they can still go on to earn just as much as someone with a high GPA, as long as they have the internal drive, work ethic, and abilities to advance.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Ellen Steverson, NCRW, GCDF, CEIC")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("GPA matters during college, on internship, graduate school, professional school (medical, pharmacy, etc.) and first job applications, but after that nobody asks―they prefer to judge you on your accomplishments in the boardroom not the classroom. Success itself is subjective—a stellar GPA could indicate success, but the act of graduating college could be success to a single mother, or graduating college without debt to a military veteran. We often correlate success with financial gain, but perhaps success is living the life you want, having a strong loving family, doing the thing you want to do, or being proud of yourself. If this is true, then GPA is far less important than visionary career and life planning.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Dr. Cheryl Minnick, NCRW, CCMC, CHJMC, CAA")])])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t12",
      "id": "c12"
    }
  }, [_vm._v("How Important to Your Career is Your First Job after College?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_c('b', [_vm._v("Your first job "), _c('i', [_vm._v("is")]), _vm._v(" important.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your first job after college is important because it is your starting point. It should be a professional-level position, meaning a position that requires a college degree as a qualification for the position.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do what you can to find a position that fits your general interests and skill, realizing that your first job will not be glamorous. Anticipate junior level titles like trainee, associate, analysts, project assistant, and the like. As best as you can, try to get a job with an employer that has a good business reputation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As you evaluate first-job opportunities, get a sense whether you will be given opportunities to do new and different things over the course of time. Try to avoid a job that is strictly mundane functions. You want to learn and grow professionally as much as the position will allow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your first job is important as your starting point and sets you up for the next job, which sets you up for the next, and so on. (See, “What You Want to Achieve in Your First Job” later in this book.)")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_c('b', [_vm._v("Your first job is "), _c('i', [_vm._v("not")]), _vm._v(" that important.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your first job is where you start. However, it will have reasonably little effect on how your career will end up over the course of the next forty to fifty years. As a professional, you will meet people and you will network. Business and job opportunities will come your way. These opportunities could take your career in directions you never imagined. Or, you will choose to explore new opportunities. It will be a journey!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As time passes, the importance of your first job will fade as your interests change, your jobs change, and life progresses.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bxt"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('i', [_vm._v("What the Coaches Say:")])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("How important is the first job out of college?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("Your first job is the first step on a career path that can lead to years of fulfilling work or a series of forgettable jobs. Spend time determining your career goals before accepting your first job. Choose an organization in which you can take pride and where you will have the opportunity to develop new skills and take on interesting projects. It is not impossible to change the direction of your career or jobs; but starting off in the right direction will save you a lot of work and anxiety.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Lorraine Beaman, MA, ACRW, CARW, NCRW, CEIC, MCD")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("I would say the first job out of college isn’t as important as your first boss out of college. I encourage recent graduates to not only search for a job around interest areas, values and strengths but to also be diligent in seeking a supervisor who can serve as a facilitator of professional growth in your first position post college. This is particularly important for the post college job seeker to find a boss who can serve as a mentor and facilitator of their growth. With this being said, while interviewing for any position, I encourage my recent graduates to be inquisitive around the work values of the supervisor, along with learn their philosophy of professional development. Any insights gained in those areas can be an indicator of what their first job will mean for them, and it can make all the difference in how they grow and thrive in their first position.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Jered Lish M.S., Gallup-Certified Strengths Coach, GCDF")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _c('p', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("People can put a lot of emphasis on the first job. However, having worked with students from high school through college, I can say it takes some people longer than others to determine the correct career path. So even if the first ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("job is one you hate, it’s better to discover that and move on to something better than to feel paralyzed by fear of making the wrong choice so they delay working. We live in an era where career paths are allowed to change, so I recommend they learn from every job, what they like and what they don’t, keep developing skills, and then continue to advance forward accordingly!")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "txr"
  }, [_vm._v("Ellen Steverson, NCRW, GCDF, CEIC")])])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t13",
      "id": "c13"
    }
  }, [_vm._v("What Employers are Looking For When Hiring New College Graduates")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("This is a difficult topic because the answers can vary widely from industry to industry and employer to employer. The contents for this topic are based on research of the topic, interviews with college placement professionals, and talent acquisition professionals.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The first thing employers are looking for is the most obvious—completion of a college degree. That achievement alone gets you to the starting line of a career and qualifies you for many career-focused positions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Experience and applicable skills"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt11",
      "id": "ch1_ft11"
    }
  }, [_vm._v("11")])]), _vm._v(" are often cited by employers when interviewing college graduates. This is why internships can be so important. Summer jobs, especially those that are relevant to the position being pursued, also have significant influence with an employer. (There is much more on how to capitalize upon internships and job experience in your job search later in the book.)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your major and GPA are varying factors depending upon the industry, employers, and position being pursued. For some employers, your major and GPA can be very important and a gateway into your career endeavors (Accounting, engineering, medicine, and many others). Or, they could be of far less concern. There are millions of college graduates who have successful careers in areas completely unrelated to their college major. It depends.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Soft skills and professional characteristics are far more significant in a successful job search than most college graduates appreciate."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt12",
      "id": "ch1_ft12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This is understandable since your primary focus in college was academic achievement. "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("This is where employers look for examples of leadership ability, communication skills (verbal, written, listening), analytical or problem solving abilities. Closely related are professional character traits such as a strong work ethic, honesty, and integrity. Employers value soft skills and professional character traits.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Often overlooked by many college graduates is an employer’s need, spoken or unspoken, for someone with business acumen or organizational vision. This is your understanding of the bigger picture. It is your understanding that to succeed an employer must generate revenue from its customers or clients. The business enterprise must be profitable. In the non-commercial world, it is your understanding of the organization’s mission. It is the understanding that your performance in the position you are pursuing must contribute to the success of the company or organization (very likely achieved in conjunction with your co-workers).")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Knowing what an employer looks for in a college graduate is important. You will have insight and a distinct competitive advantage against others who have not thought this through.")])]), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "bxt"
  }, [_c('i', [_vm._v("What the Coaches Say:")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("In your experience, what are employers looking for when hiring a recent college graduate?")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Today’s workplace is constantly changing. However, certain skills are basic requirements that will never change. It is important to have excellent communication and writing skills. This is particularly important in a world of texting and emoji’s where communication is carried out using symbols and “made-up” abbreviations.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Employers are also looking for initiative and creativity. They are looking for someone who is eager to learn and is not afraid to share their thoughts and opinions to add value. New college graduates must also be able to work as a team as well as independently. They must be self-directed and be able to work with little supervision. This is especially important in today’s workplace where work is conducted from any location at any time and not necessarily from the corporate office.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Below are some of the key skills needed to succeed in the 21st century workplace according to Hanover Research:")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Collaboration and teamwork")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Creativity and imagination")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Problem solving")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Global and cultural awareness")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Leadership")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Oral and written communication skills")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Technology literacy")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Innovation")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Critical thinking")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Flexibility and adaptability")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Information literacy")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Civic literacy and citizenship")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Social responsibility and ethics")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Initiative")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Juliet Murphy, MBA, MA")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("From my experience employers report looking for innovative, team oriented, strong communicators, and solutions based thinkers, who can thrive in the complexities of the unknowns and the unexplored. In short, companies want to hire creative, smart, fun, engaging, critically thinking, hard-working graduates who also have a high emotional intelligence. Now how does a recent graduate articulate all of that to them? I was speaking with a recruiter from Google and was asking them if they could give any piece of advice to students pursing software engineering positions at their company, what they would recommend. I was surprised to learn they will often score a resume higher if they saw tutoring in a recent graduate’s documents. This insight was particularly interesting to me because it validated the importance of soft skills such as communication and coaching, and it was apparent as a value of Google to find good critical thinkers who have great soft skills.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("I was speaking with a CEO out in San Diego who owns a staffing company, and he shared he often scored resumes higher if he saw a student was an athlete. His company has a high performing sales team and he attributes the recruitment of athletes being tied to them being team oriented, competitive, and disciplined, and those are attributes he seeks when hiring recent graduates. With these two examples in mind, employers seek out candidates who they theorize will be strong contributors to their teams, and it’s through ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("impressive experiences, competencies gained and soft skills demonstrated, do most candidates advance when those attributes are presented.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "txr"
  }, [_vm._v("Jered Lish M.S., Gallup-Certified Strengths Coach, GCDF")])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t14",
      "id": "c14"
    }
  }, [_vm._v("Who Hires New College Graduates?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("You graduated from college and soon learn that many of the positions that appeal to you require previous experience. It’s a conundrum. How can you get hired for jobs that require experience but you can’t get experience unless you get hired?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Fortunately, there are a lot of employers that hire recent college graduates! Check out "), _c('a', {
    attrs: {
      "href": "http://collegegrad.com",
      "id": "Ag9",
      "target": "_blank"
    }
  }, [_vm._v("collegegrad.com")]), _vm._v(" (specifically, "), _c('a', {
    attrs: {
      "href": "http://collegegrad.com/topemployers",
      "id": "A4X",
      "target": "_blank"
    }
  }, [_vm._v("collegegrad.com/topemployers")]), _vm._v("). There you will find an extensive list of employers that hire entry level employees. Below is an example of a recent list:")]), _vm._v(" "), _c('table', {
    staticClass: "table-border",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdc1"
  }, [_c('b', [_vm._v("Employer Name")])]), _vm._v(" "), _c('td', {
    staticClass: "tdc1"
  }, [_c('b', [_vm._v("Hires")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Enterprise Rent-A-Car")]), _vm._v(" "), _c('td', [_vm._v("9500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("EY")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("5000")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hertz")]), _vm._v(" "), _c('td', [_vm._v("4500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("The Progressive Corporation")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("4200")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("PxC")]), _vm._v(" "), _c('td', [_vm._v("3900")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("KPMG LLP")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("3300")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Deloitte")]), _vm._v(" "), _c('td', [_vm._v("3000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Federal Bureau of Investigation")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("2900")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Avis Budget Group")]), _vm._v(" "), _c('td', [_vm._v("2500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Bank of America")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("2500")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("U.S. Customs and Border Protection")]), _vm._v(" "), _c('td', [_vm._v("2200")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Vanguard")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("1850")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("General Electric")]), _vm._v(" "), _c('td', [_vm._v("1600")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_c('a', {
    attrs: {
      "href": "http://Amazon.com",
      "id": "AZF",
      "target": "_blank"
    }
  }, [_vm._v("Amazon.com")])]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("1500")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Epic")]), _vm._v(" "), _c('td', [_vm._v("1500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Intel")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("1500")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("National Security Agency")]), _vm._v(" "), _c('td', [_vm._v("1500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("The PNC Finanical Sercies Group")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("1500")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Chevron")]), _vm._v(" "), _c('td', [_vm._v("1400")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdg"
  }, [_vm._v("Sodexo")]), _vm._v(" "), _c('td', {
    staticClass: "tdg"
  }, [_vm._v("1400")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Pursue companies that may be in your industry of interest, but don’t be too restrictive. Open your mind to new avenues. For example, the first company on the above list is Enterprise-Rent-A-Car®. You may not want to pursue a career in the rental car business—that’s fine. However, did you know that many of the employers listed above are “recruiting sources” for other employers once you have one to three years of successful experience working in the real world? It’s true! Just because you start with a company in an industry right out of school doesn’t mean that you have to pursue that career track long term. The key is to get experience in the real world that can qualify you for the next better opportunity.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course, there are exceptions. If you want to pursue a career in engineering, you need to land in an engineering firm or something related to engineering. The same would hold true for accounting and other industries. The point remains the same: The key to launching a career is getting a job in the real or commercial world, create a track record of success, and gain experience. From there you can springboard to new and better opportunities. Where you start will not determine where you end up fifty years from now when you choose to close out your professional career. But, the point is to get a good start.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t15",
      "id": "c15"
    }
  }, [_vm._v("Common Job Search Mistakes of Recent College Graduates")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("On average, it takes recent college graduates about six months to land their first career-level position."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt13",
      "id": "ch1_ft13"
    }
  }, [_vm._v("13")])]), _vm._v(" That timeline can be longer if you make job search mistakes. Below are some of the common job search mistakes graduates make that can lengthen a job search. "), _c('b', [_c('i', [_vm._v("Not Contacting Your Career Placement Center.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This next statement is written in the tone of a parent:")]), _vm._v(" "), _c('div', {
    staticClass: "bkt"
  }, [_c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("“Walk your butt over to the Career Placement Office and introduce yourself!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That office and the people in it are there to help you. Let them! Most, if not all, of their services are free or of little cost. Use them. There are a wide range of services the Career Placement Office can provide. Some provide more than others. Some Career Placement Offices are better than others. The only way to know how much help there is for you is to talk to these people and learn. Regardless, having another resource to help in your job search doesn’t hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('i', [_vm._v("Waiting to start job search.")])])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The longer you put off starting your job search, the longer it will take to land your first career-level position. Ideally, begin to prepare for your job search one to two semesters before graduation. The key is not to wait. Start putting together the tools for your search now if you haven’t already. You want to avoid starting your search until after all the graduation parties are over. If you wait, you could miss out on good opportunities that may lead to even better jobs. Read the job search checklist and get moving.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Failure to clean up all social media accounts.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Get into all of your social media accounts and clean them up. Read the topic, "), _c('i', [_vm._v("Clean Up All Social Media Before Starting a Job Search")]), _vm._v(" for more detailed information.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Not having a job search plan.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When you follow the guidance in this book, you have a job search plan! Not only do you have a plan, you have instruction on how to execute that plan. All that’s needed now is your effort. Put the plan in action and you are on your way!")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Not fully utilizing LinkedIn.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("LinkedIn is clearly the dominant career social website in the world. To fully leverage its power requires an optimized LinkedIn profile. Read the topic on LinkedIn and optimize your profile. Activate the Open Candidates Feature and signal employers and talent acquisition professionals that you are looking for a job. Doing both of these (optimizing your profile and activating the Open Candidate Feature) makes you discoverable so employers can "), _c('i', [_vm._v("contact you")]), _vm._v(" about jobs!")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("A boring resume.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Too many recent college graduates have “boring college biographies” rather than impactful resumes that intrigue and sell potential. A resume is a marketing piece—it’s advertising! How it presents you on paper creates an impression in the mind of the reader. Read the Impactful Resumes topic and your resume will not be boring but will stand out amongst your peers.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("Over-reliance on posted job openings.")])])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("It’s a digital age and you will explore job boards and job websites for opportunities. The ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("job search mistake, however, is relying on these posted job openings as your only source for job leads. Applying for a job online does not work as well as you might believe. In fact, it is inefficient due to the sheer volume of potential applicants. A far more effective approach is the strategies promoted in this book—a proactive, self-motivated job search where you take yourself to the market rather than reacting to what the job market advertises.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bxt"
  }, [_c('i', [_vm._v("What the Coaches Say:")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("In your experience, what are the common job search mistakes that recent college graduates make?")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("The most common mistakes I see are:")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Not having a clear picture of their employment goal.")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Waiting until after graduation to start a job search.")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Assuming their college career center will find them a job.")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Not understanding the job search process.")]), _vm._v(" "), _c('p', {
    staticClass: "hangul"
  }, [_vm._v("• Not asking for help.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Lorraine Beaman, MA, ACRW, CARW, NCRW, CEIC, MCD")])])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t16",
      "id": "c16"
    }
  }, [_vm._v("A Gap Year and Your Job Search")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("A “gap year” is that period of time after college when you take a break before entering your career (or graduate school). There are a number of advantages and career hazards to a gap year. The purpose of this section is to discuss the job search ramifications of a gap year.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From a job market point of view, it is generally acceptable to most employers to have taken a gap year so long as your time was spent with a purpose. For example, teaching school in impoverished areas in Latin America, AmeriCorps, or any one of hundreds of worthy causes or endeavors.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your time off does not necessarily need to be spent on high noble purposes—spending a year traveling the world exposing yourself to different cultures and lifestyles, for example. "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("In many cases, the gap year experience can enhance your candidacy with some employers. Some view these experiences as “maturing events” that make you a better employee.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "bxt"
  }, [_c('i', [_vm._v("What the Coaches Say:")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("What is your advice to college graduates who have taken a gap year after graduation?")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Be able to explain why the gap year experience makes you a more competitive candidate. Most graduates taking a gap year work on projects, build relationships, and achieve goals that demonstrate the soft skills employers are seeking. Whether you spend your year doing home repair or traveling around Europe, you can show how you developed and executed a plan and talk about the people you networked with during the process.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Lorraine Beaman, MA, ACRW, CARW, NCRW, CEIC, MCD")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("I think it’s acceptable for some students. However, it can really make it much more difficult and can appear the student is just lazy. So unless they are doing something very productive during the gap year, like traveling, learning to be a global citizen, or volunteering, most students cannot afford the luxury of a gap year.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Ellen Steverson, NCRW, GCDF, CEIC")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Enjoy the year but spend it in a meaningful way: live at home to save money for first/last month rent and a U-Haul, pay down debt, volunteer and network in your area of career interest, explore careers by job shadowing, take career assessments, conducting online and in-person research for graduate or professional schools, teach English abroad, tour the world, take online certification courses to build skills, maybe unwind and relax, but have a strategy, goal and a benchmark for success. Don’t waste the year.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Dr. Cheryl Minnick, NCRW, CCMC, CHJMC, CAA")])]), _c('p', {
    staticClass: "tx2"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("I think GAP years are awesome if the time is spent wisely. GAP years can serve as a pivotal time of reflection, a time of growth, and a time of exploration. I’ve had students who have struggled with a variety of mental health disorders go and take a GAP year in order to heal their minds, and learn how to navigate the challenges they were facing in a productive and healthy way. The intentionality of their time spent in self growth multiplied exponentially for them because they returned to their career goals focused, empowered, and no longer were at risk from life burn out. It was truly a gift to see the growth they experienced in that year, and it was time well invested. If a recent graduate can, in their GAP year, identify ways they can continually and intentionally grow whether in an experience capacity or a skills capacity, GAP years can absolutely be beneficial.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "txr"
  }, [_vm._v("Jered Lish M.S., Gallup-Certified Strengths Coach, GCDF")])])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("What does not play so well with employers is when you take a gap year to “find yourself,” you move home, and proceed to do nothing. Or, worse yet, when you take a gap year, get a job tending bar, only to wake up when you’re thirty and you’ve had six bartending jobs in the last eight years. Launching your professional level career now will be difficult, if not insurmountable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you pursue a gap year, do so with a well-thought purpose in mind. You must be able to tell a potential employer a “story” of what you did, why you did it, what you learned, and (this is the important part) how the experience benefits the employer with you as a better employee because of the gap year experience.")])]), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('p', {
    staticClass: "bxt"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('i', [_vm._v("What the Coaches Say:")])])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("Is a gap year the death-knell of securing a professional-level job?")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Students should have a plan before they just take a year off since that gap will influence a hiring manager’s decision to interview/hire or not. They may have to look much longer and network more to land a job after the gap. However, it shouldn’t be the death-kneel of securing a job and they should have a plan to communicate the value and what they learned over the year while aligning it to career goals or the target job"), _c('b', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Ellen Steverson, NCRW, GCDF, CEIC")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Absolutely not. A GAP year from my perspective if done right, can yield even more professional and personal opportunities. In short, a GAP year serves as an opportunity to continue to self-reflect on values, goals, and aspirations in life, and that process of self-reflection helps with life focus and deliberation of next steps in a person’s career.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("I once counseled a dermatology resident at a medical school I worked at who had an incredibly impressive background. He graduated Johns Hopkins at the age of 19, graduated medical school at the age of 23, and landed a top residency in California for dermatology by the age of 24. After speaking with him about his impressive journey, this talented young physician did share that his only regret so far in life was not taking a GAP year post undergrad. His reasoning was a GAP year would have enabled him to pursue life curiosities he was thinking about outside of medicine, and given the formative years he was in, he jokingly reflected on how he might have turned out had the real world been his teacher at the age of 19 instead of medical school. He’s happy and grateful for where he is at now, proud of the things he accomplished, and in retrospect admires the power a GAP year can have in a person’s life.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Jered Lish M.S., Gallup-Certified Strengths Coach, GCDF")])])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t17",
      "id": "c17"
    }
  }, [_vm._v("Dealing with a Criminal Record")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("You did something you should not have been doing, got caught, and now you have a criminal record. Most employers will perform a background check, so ignoring your record and hoping it will not affect your job search is not a good strategy. Fortunately, there are steps you can take that can minimize your mistake from significantly harming your job search and your future career.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('b', [_vm._v("Sealing or Expunging Your Record")]), _vm._v(". Contact your attorney and see if your criminal record can be sealed or expunged. Generally speaking, when a record is sealed your conviction remains on your record but only law enforcement and the district attorney’s office can see it. The general public cannot see it and this includes employers. If your record is expunged, the conviction is removed from your record as if it never even happened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Virtually all states allow a prior criminal record to be sealed or expunged depending on the offense and the offender. The younger you were at the time of the offense is helpful. It allows your attorney to argue that your criminal behavior was the foolishness of your youth. If your offense was “victimless,” your attorney can argue that you are not a danger to the community. Offering the completion of a college degree, good G.P.A., college activities, and no additional criminal offenses are all helpful to persuade the court that you deserve a second chance with a clean record.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you pursue this strategy, contact your attorney right away. These types of proceedings can take several months.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('b', [_vm._v("Broaden Your Target Company List")]), _vm._v(". Your criminal record (if it is not sealed or expunged) can, and likely will, affect whether certain companies can hire you. Since your pool of employers will be smaller, you need to expand the number of potential employers and open your mind to fields of endeavor you may not have considered or even know about. Identify companies and industries where you believe your conviction could be of less concern.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Focus your job search efforts towards smaller to mid-sized companies. These employers may be more understanding or forgiving of your past.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('b', [_vm._v("Be Honest")]), _c('i', [_vm._v(".")]), _vm._v(" Do not hide your criminal record from employers. Be honest and forthright about your past. You will be in a far better position and be viewed more favorably by putting the topic on the table and explaining the events. Honesty is a valued character trait. Being straightforward with the employer about the existence of your criminal record shows you are honest and many employers will tell you that they appreciate the honesty. On the other hand, if you try to hide your criminal record and you are discovered, which "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("will happen sooner or later, you risk being viewed (this is intended to sound harsh) as an “educated convict” and a risky hire. The message here is do the right thing and be honest.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("You must emphasize to the employer that you take full responsibility for your actions, and that you were foolish (or wrong). Then, most importantly, state that you have learned from your mistake, that you never again want to be mired up in the criminal justice system, and the employer will not need to worry about anything like that happening again. Then, turn the interview towards the positive aspects for hiring you, such as your college activities, summer jobs, positive traits like work ethics and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Having a criminal record as a recent college graduate does not end your career before it starts. It can make things more difficult to initially get started, but it is not insurmountable. Take heart, there are good employers who will be forgiving and will hire you.")])]), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "bxt"
  }, [_c('i', [_vm._v("What the Coaches Say:")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("What is your advice for college graduates who have a criminal record?")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("It is better to tell employers you have a criminal record than have them find out when they do a background check. The good news is many employers understand that humans make mistakes; it is what they do about it that matters. There are employers who pride themselves on giving people a second chance. When you respond to questions about your background, take responsibility for what you did and share what you learned from the experience that will make you a better employee.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Lorraine Beaman, MA, ACRW, CARW, NCRW, CEIC, MCD")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _c('p', {
    staticClass: "tx1"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Depending on the depth and severity of the criminal record, there are definitely ways in which opportunities can be generated. This topic can be incredibly complex and every individual’s situation is different. In general, it can be advantageous for the recent graduate to target locations that may not be as popular and desirable for job placement; for instance, in smaller cities, colder cities, and more rural communities. Essentially the strategy ")]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("I’m recommending is the “go where the employers are who will hire you” approach, and this can be an effective job search strategy as long as the recent graduate isn’t overly picky or bound to a particular geographical location.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "txr"
  }, [_vm._v("Jered Lish M.S., Gallup-Certified Strengths Coach, GCDF")])])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t18",
      "id": "c18"
    }
  }, [_vm._v("The Psychology of Persuasion and Your Job Search")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Before we dive into the steps and techniques for conducting a college graduate job search, it’s beneficial to talk briefly about the psychology of persuasion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What follows are some very important concepts woven throughout the rest of this book. Knowing them will help you maximize your job-search success because they combine so effectively with the self-motivated approach.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("According to Robert Cialdini, a leader in the field of psychology and persuasion, there are six principles that persuade others to think and act as they do:")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_vm._v("1. Scarcity")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_vm._v("2. Authority")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_vm._v("3. Liking (and Personal Chemistry)")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_vm._v("4. Social Proof")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_vm._v("5. Commitment and Consistency")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_vm._v("6. Reciprocity/Reciprocation"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt14",
      "id": "ch1_ft14"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx12"
  }, [_vm._v("Let’s discuss each principle and how it affects your job search.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Scarcity")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If a recent college graduate is viewed to be unique or special, he or she is seen as valuable."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt15",
      "id": "ch1_ft15"
    }
  }, [_vm._v("15")])]), _vm._v(" How do you capitalize upon the persuasion principle of scarcity? Answer: Differentiation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Much of this book is about creating differentiation (separation) between you and other "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("college graduate job seekers. During the course of the interviewing process, seemingly small and isolated thoughts of differentiation compound upon themselves in the mind of the hiring executive, such as if he/she dresses well, displays desirable character traits, has internship experience, a good GPA, interviews well, and so on. All of this affects your perceived value and motivates the hiring executive to continue the interviewing process with you, hopefully ending in an employment offer.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The more unique you can justifiably portray yourself, the more you are using the persuasion principle of scarcity.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Authority")])])])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Most people respond to and respect authority, whether it is a title, position, professional designation, experience, or station in life."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ch1_nt16",
      "id": "ch1_ft16"
    }
  }, [_vm._v("16")]), _vm._v(" A good example of creating intangible authority is appropriate interview attire: A starched white shirt or stylish blouse, pressed suit, polished hard-soled shoes, the pen you use, or even the watch you wear can all project professional authority that others may react to favorably. This applies to a recent college graduate as well as a tenured professional.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Any job search technique or information that triggers professional respect with the hiring executive is using the persuasion principle of authority.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Liking (and Personal Chemistry)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sixty percent of most hires are based on personal chemistry."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt17",
      "id": "ch1_ft17"
    }
  }, [_vm._v("17")])]), _vm._v(" In other words, hiring executives are persuaded to hire job seekers they personally like. Getting others to like you is often based on similarity or common interests. We tend to like other people similar to ourselves."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#ch1_nt18",
      "id": "ch1_ft18"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There are several ways to lay the foundation for similarity and personal chemistry. Here are a few ideas:")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_vm._v("1. Common personal interests.")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_vm._v("2. Attending a common college or university.")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("3. Giving the hiring executive a sincere compliment.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "hangolt"
  }, [_vm._v("4. Name dropping (identifying common friends or a professional colleague that the hiring executive feels good about).")]), _vm._v(" "), _c('p', {
    staticClass: "tx12"
  }, [_vm._v("Any job search technique that creates a positive impression on the hiring executive based on association or personal chemistry is using the persuasion principle of liking (and personal chemistry).")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Social Proof")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What others say about you is more persuasive than what you say about yourself. That’s the power of social proof.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Psychologically, social proof is more influential and persuasive when decisions are shrouded in uncertainty. A hiring executive may be thinking: Which of these college graduates is better qualified? Who would fit in best? What about compensation? This is why recommendations, references, or any form of affirmation from a trusted source can impact the hiring decision.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Any job search technique that contains a recommendation or positive affirmation of you as a qualified college graduate (and as a person) is using the persuasion principle of social proof.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Consistency and Commitment")])])])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("People desire a reputation of upholding their own commitment and generally do not like to go back on their word."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ch1_nt19",
      "id": "ch1_ft19"
    }
  }, [_vm._v("19")]), _vm._v(" It’s that simple.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An example of this principle in action is when you close an interview by asking if you will be proceeding in the process. If the hiring executive indicates that you will, it will be more difficult to retreat from that answer due to the persuasion principle of consistency and commitment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Any job search technique that tends to bind a hiring executive to a self-imposed course of action is using the persuasion principle of consistency and commitment.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('i', [_vm._v("Reciprocation")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There is a strong psychological motivation to return favors and not to feel indebted to "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("others. People feel the compulsion to repay another. This can be especially true if the item (of whatever nature) was given for free."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#ch1_nt20",
      "id": "ch1_ft20"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An example of using this persuasion technique in a job search is offering to help the hiring executive in some way. This will not be easy given your limited experience, but be on the lookout for those opportunities should they present themselves. To be most effective, the gesture should be done with the expectation of receiving nothing in return, but with the awareness that the psychology of reciprocity is present.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Any job search technique that endears you to a hiring executive by doing something for him or her (especially for free) is using the persuasion principle of reciprocity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By raising your awareness to these persuasion principles, you will be on the alert for opportunities to capitalize upon them when opportunities present themselves. You can use the psychology to advance your candidacy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now that you have a basic understanding of the principles of persuasion, you understand the reasons for (and persuasive power of) many of the job search techniques presented throughout this book—the same techniques used by many others, to their success. Occasional reference is made to these persuasion principles to help your job search be more effective.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#t19",
      "id": "c19"
    }
  }, [_vm._v("★ "), _c('b', [_vm._v("Getting Off to a Successful Start")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Beyond “I need to write my resume,” many college graduates don’t know what to do or in what order to do things to get started in their job search. It can easily become overwhelming. In this topic we will list, then briefly discuss, the A-1 priorities to successfully launch your job search and reduce any feelings of anxiety:")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_c('b', [_vm._v("1. Get organized.")]), _vm._v(" You will need to make lists—of companies, people, and “to-do” lists. Think through how you will keep track of everything. Create a system that works for you. Relying on your memory or sticky-notes in a shotgun fashion is a recipe for disaster. In the thick of your job search, you won’t be able to keep track of what you’re doing without a system. Excel spreadsheets are highly recommended for creating lists of companies and people. Only create columns for the information you will really need (name of contact, company, company website, email address, phone number, date contacted). Don’t get carried away recording non-useful information. There are commercial services that can help you stay organized in your job search. "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("Check out JibberJobber (")]), _c('a', {
    attrs: {
      "href": "http://www.jibberjobber.com",
      "id": "AhZ",
      "target": "_blank"
    }
  }, [_vm._v("www.jibberjobber.com")]), _vm._v(") and Career"), _c('i', [_vm._v("Shift")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "http://www.careershift.com",
      "target": "_blank"
    }
  }, [_vm._v("www.careershift.com")]), _vm._v("). Microsoft Outlook’s calendar feature can also help. You can record tasks to be done, schedule follow-up calls, and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_c('b', [_vm._v("2. Create or update your resume.")]), _vm._v(" Read the Impactful Resumes section, and either prepare one yourself, or seek professional services (which will free your time for other job search activities, but it will incur a cost). Having your resume professionally done could be a good investment. The end product will likely look better than those who do it themselves. Refer to (and perhaps contact) the resume writers who have provided sample resumes later in the book.")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_c('b', [_vm._v("3. Create or update your LinkedIn profile and expand your network.")]), _vm._v(" Consult the LinkedIn section in this book and optimize your LinkedIn profile. Make sure your resume and LinkedIn profile are in sync with each other (especially the names of former employers, internships and dates). After you look over the Networking chapter, expand your network by adding new connections through LinkedIn (it’s not as hard as you may think). These connections have to be the right kind of high-value connections (explained later) that will advance your job search.")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_c('b', [_vm._v("4. Identify your keywords.")]), _vm._v(" What words apply to you? Start simple. What character traits apply to you? What industries do you want to work in? What technical knowledge do you have? These concepts and others will form the messaging behind who you are and how you present yourself to the job market. They will be used in your resume, LinkedIn profile, personal branding, and elevator speech among others. There will be much more on keywords as you progress through the book.")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_c('b', [_vm._v("5. Create job alerts.")]), _vm._v(" Use websites like "), _c('a', {
    attrs: {
      "href": "http://Indeed.com",
      "id": "Ao3",
      "target": "_blank"
    }
  }, [_vm._v("Indeed.com")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://SimplyHired.com",
      "id": "APZ",
      "target": "_blank"
    }
  }, [_vm._v("SimplyHired.com")]), _vm._v(". You can choose to be alerted about titles, locations, specific companies, and so on. Set up job alerts on LinkedIn too. Companies (and recruiters) post jobs on LinkedIn and you can receive notifications when they do. Are there any industry-specific or niche job boards you could search? Get a sense of the job market, and start the flow of information on opportunities coming to you about jobs you are looking for. If a position pops up, and you’re interested, "), _c('b', [_vm._v("do not")]), _vm._v(" apply for it through the website! Research the likely hiring executive(s) and contact them directly first.")]), _vm._v(" "), _c('p', {
    staticClass: "hangolt"
  }, [_c('b', [_vm._v("6. Create a short list of target employers you would be interested in working for.")]), _vm._v(" It may be only two, five, or ten companies to start with. Add to the list as you discover new companies. But the point here is to start the list that gets you thinking. Now, "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("look up the companies on LinkedIn. Follow them by setting up alerts to receive news, press releases, and job postings. Google Alerts may also be used. If you have Twitter, follow the companies. This starts the flow of information from these companies (and others you’ll add), including jobs and industry trends, which will benefit your job search. Add this information to your Excel spreadsheets to create a complete picture of each company before moving ahead, to eliminate needless backtracking for additional research.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "hangolt"
  }, [_c('b', [_vm._v("7. Create a short list of networking contacts.")]), _vm._v(" This one is like the list of companies from the last step. Make a list of friends, family, and all professional-level contacts you have. This includes all contacts that your parents may have, including financial planners, bankers, dentists, and the list goes on. As you think of people, add to the list. This list likely will not exceed ten to fifteen names to begin with (although it could be more). After you make out the list, "), _c('b', [_vm._v("do not")]), _vm._v(" contact them! You are not ready (even though you may think you are). Regardless of the level of the relationships, don’t blow it by not being properly prepared. Be patient. Read the Professional Networking section, and do things right the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These seven action items establish the foundation for your job search. Once you have these in place, other action items will naturally follow. Having the right starting point gets you off to a good start.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("_______________")])]), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#ch1_ft3",
      "id": "ch1_nt3"
    }
  }, [_vm._v("3")]), _vm._v(" “Goodnight, Seattle: "), _c('span', {
    attrs: {
      "href": "#/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2")]), _vm._v(".” "), _c('i', [_vm._v("Frasier")]), _vm._v(". 13 May 2004 by NBC. Directed by David Lee and written by Christopher Lloyd and Joe Keenan.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft4",
      "id": "ch1_nt4"
    }
  }, [_vm._v("4")]), _vm._v(" LinkedIn, “Using LinkedIn to Find a Job”; Beatty, “The Math Behind the Networking Claim”; Rothberg, “80% of Job Openings.”")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft5",
      "id": "ch1_nt5"
    }
  }, [_vm._v("5")]), _vm._v(" Smith, Jacquelyn. “7 Things You Probably Didn’t Know About Your Job Search.” "), _c('i', [_vm._v("Forbes")]), _vm._v(". April 17, 2013. "), _c('a', {
    attrs: {
      "href": "http://www.forbes.com/sites/jacquelynsmith/2013/04/17/7-things-you-probably-didnt-know-aboutyour-job-search/#71fe2c6e64e6",
      "id": "A1n",
      "target": "_blank"
    }
  }, [_vm._v("http://www.forbes.com/sites/jacquelynsmith/2013/04/17/7-things-you-probably-didnt-know-aboutyour-job-search/#71fe2c6e64e6")]), _vm._v(" (accessed February 12, 2016).")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft6",
      "id": "ch1_nt6"
    }
  }, [_vm._v("6")]), _vm._v(" Herman, Lily. “How to Clean Up Your Social Media During the Job Search.” "), _c('i', [_vm._v("The Muse")]), _vm._v(". "), _c('a', {
    attrs: {
      "href": "https://www.themuse.com/advice/how-to-clean-up-your-social-media-during-the-job-search",
      "id": "At6",
      "target": "_blank"
    }
  }, [_vm._v("https://www.themuse.com/advice/how-to-clean-up-your-social-media-during-the-job-search")]), _vm._v(". (Accessed May 22, 2017).")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft7",
      "id": "ch1_nt7"
    }
  }, [_vm._v("7")]), _vm._v(" Nauen, Rachel, “Number of Employers Using Social Media to Screen Candidates at All-Time High, Finds Latest CareerBuilder Study.” "), _c('i', [_vm._v("CareerBuilder")]), _vm._v(", June 15, 2017, "), _c('a', {
    attrs: {
      "href": "http://press.careerbuilder.com/2017-06-15-Number-of-Employers-Using-Social-Media-to-Screen-Candidates-at-All-Time-High-Finds-Latest-CareerBuilder-Study",
      "id": "Ark",
      "target": "_blank"
    }
  }, [_vm._v("http://press.careerbuilder.com/2017-06-15-Number-of-Employers-Using-Social-Media-to-Screen-Candidates-at-All-Time-High-Finds-Latest-CareerBuilder-Study")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft8",
      "id": "ch1_nt8"
    }
  }, [_vm._v("8")]), _vm._v(" Ibid")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft9",
      "id": "ch1_nt9"
    }
  }, [_vm._v("9")]), _vm._v(" Ibid")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft10",
      "id": "ch1_nt10"
    }
  }, [_vm._v("10")]), _vm._v(" “The Role of Higher Education in Career Development: Employer Perceptions.” "), _c('i', [_vm._v("The Chronicle of Higher Education.")]), _vm._v(" December 2012. "), _c('a', {
    attrs: {
      "href": "http://www.chronicle.com/items/biz/pdf/Employers%20Survey.pdf",
      "id": "Afx",
      "target": "_blank"
    }
  }, [_vm._v("http://www.chronicle.com/items/biz/pdf/Employers%20Survey.pdf")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft11",
      "id": "ch1_nt11"
    }
  }, [_vm._v("11")]), _vm._v(" Lorenz, Mary., “New study shows job seekers what hiring managers really want.” "), _c('i', [_vm._v("CareerBuilder")]), _vm._v(". May 17, 2016. "), _c('a', {
    attrs: {
      "href": "http://www.careerbuilder.com/advice/new-study-shows-job-seekers-what-hiring-managers-really-want",
      "id": "AWI",
      "target": "_blank"
    }
  }, [_vm._v("http://www.careerbuilder.com/advice/new-study-shows-job-seekers-what-hiring-managers-really-want")]), _vm._v(" (Accessed August 27, 2017). (77% of employers are looking for candidates with the skills that match what they need.)")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft12",
      "id": "ch1_nt12"
    }
  }, [_vm._v("12")]), _vm._v(" Ibid., (63% of employers are looking for the right soft skills.)")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft13",
      "id": "ch1_nt13"
    }
  }, [_vm._v("13")]), _vm._v(" “Manage Your Career,” "), _c('i', [_vm._v("Experience")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "https://www.experience.com/alumnus/article?article_id=article_1247505066959&channel_id=career_management&source_page=additional_articles",
      "id": "AlG",
      "target": "_blank"
    }
  }, [_vm._v("https://www.experience.com/alumnus/article?article_id=article_1247505066959&channel_id=career_management&source_page=additional_articles")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft14",
      "id": "ch1_nt14"
    }
  }, [_vm._v("14")]), _vm._v(" Cialdini, Robert. "), _c('i', [_vm._v("Influence: Science and Practice")]), _vm._v(", 4th ed. Needham Heights, MA: Allyn & Bacon, 2001, quoted in Kurtzberg and Naquin, Essentials, "), _c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5")]), _vm._v(", p. 94–101.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft15",
      "id": "ch1_nt15"
    }
  }, [_vm._v("15")]), _vm._v(" Cialdini, Robert. "), _c('i', [_vm._v("Influence")]), _vm._v(". p. 204–205, and "), _c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 7")]), _vm._v(", “Scarcity: The Rule of the Few,” quoted in Kurtzberg and Naquin, "), _c('i', [_vm._v("Essentials")]), _vm._v(", p. 94–101.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft16",
      "id": "ch1_nt16"
    }
  }, [_vm._v("16")]), _vm._v(" Cialdini, "), _c('i', [_vm._v("Influence")]), _vm._v(", p. 180–185, and "), _c('span', {
    attrs: {
      "href": "#/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 9")]), _vm._v(", “Authority: Directed Deference,” quoted in Kurtzberg and Naquin, "), _c('i', [_vm._v("Essentials")]), _vm._v(", p. 94–101.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft17",
      "id": "ch1_nt17"
    }
  }, [_vm._v("17")]), _vm._v(" DiResta, Diane. Interview by Christina Canters, “Episode 29—How to Blitz Your Job Interview—Secrets of Executive Speech Coach Diane Diresta.” "), _c('i', [_vm._v("DesignDrawSpeak")]), _vm._v(". Podcast audio, June 12, 2014. "), _c('a', {
    attrs: {
      "href": "http://designdrawspeak.com/029/",
      "id": "AkfS",
      "target": "_blank"
    }
  }, [_vm._v("http://designdrawspeak.com/029/")]), _vm._v(" (accessed June 19, 2015).")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft18",
      "id": "ch1_nt18"
    }
  }, [_vm._v("18")]), _vm._v(" Byrne, Donn Erwin. "), _c('i', [_vm._v("The Attraction Paradigm")]), _vm._v(". New York: Academic Press, 1971. Quoted in Kurtzberg and Naquin, "), _c('i', [_vm._v("Essentials")]), _vm._v(", p. 35.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft19",
      "id": "ch1_nt19"
    }
  }, [_vm._v("19")]), _vm._v(" Cialdini, "), _c('i', [_vm._v("Influence")]), _vm._v(", p. 53, and "), _c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v(", “Commitment and Consistency: Hobgoblins of the Mind,” quoted in Kurtzberg and Naquin, "), _c('i', [_vm._v("Essentials")]), _vm._v(", p. 94–101.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/#ch1_ft20",
      "id": "ch1_nt20"
    }
  }, [_vm._v("20")]), _vm._v(" Cialdini, "), _c('i', [_vm._v("Influence")]), _vm._v(", p. 144, 161, and "), _c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5")]), _vm._v(", “Liking: The Friendly Thief,” quoted in Kurtzberg and Naquin, "), _c('i', [_vm._v("Essentials")]), _vm._v(", p. 94–101.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baaaf0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 111
// module chunks = 0